import React, { useContext } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { reduce, partial } from "lodash";
import queryString from "query-string";
import { dispatchActionCreator } from "../../utils/general";
import TrackingActions from "../../actions/TrackingActions";

export const TrackingContext = React.createContext();

export const trackingActionCreator = (dispatch, trackingAction, params) => () =>
  dispatch(trackingAction(params));

export const Provider = ({ children, trackingActions, location }) => {
  const dispatch = useDispatch();
  const { variant } = queryString.parse(location.search);

  return (
    <TrackingContext.Provider
      value={{
        trackingActions,
        trackingActionCreator: partial(trackingActionCreator, dispatch),
        pageUrl: location.pathname,
        pageVariant: variant,
        dispatch,
      }}
    >
      {children}
    </TrackingContext.Provider>
  );
};

Provider.propTypes = {
  children: PropTypes.any,
  trackingActions: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

const mapDispatchToProviderProps = (dispatch) => {
  return {
    trackingActions: reduce(
      TrackingActions,
      (res, action, key) => {
        res[key] = dispatchActionCreator(dispatch, action);

        return res;
      },
      {}
    ),
  };
};

export const useTracking = () => useContext(TrackingContext);

export const TrackingProvider = withRouter(
  connect(null, mapDispatchToProviderProps)(Provider)
);
